import { useAppSelector } from "../app/hooks";
import {
  selectLanguageSkillsArray,
  selectLanguageSkillsCodeNameIndex,
} from "../features/languageSkills/languageSkillsSlice";

const useLanguageSkills = () => {
  const languageSkills = useAppSelector((state) =>
    selectLanguageSkillsArray(state),
  );

  // Sort based on names
  const sortedLanguageSkills = languageSkills.sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  const languageSkillCodeNameIndex = useAppSelector((state) =>
    selectLanguageSkillsCodeNameIndex(state),
  );

  const getLanguageSkillsNameByCode = (code: string) => {
    return languageSkillCodeNameIndex[code] || code;
  };

  return { sortedLanguageSkills, getLanguageSkillsNameByCode };
};

export default useLanguageSkills;
